/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * DriverFamiliarityScoreDtoBase
 * auto generated base class for the model DriverFamiliarityScoreDtoModel.
 */
export const DriverFamiliarityScoreDtoModelBase = ModelBase
  .named('DriverFamiliarityScoreDto')
  .props({
    __typename: types.optional(types.literal("DriverFamiliarityScoreDto"), "DriverFamiliarityScoreDto"),
    score: types.union(types.undefined, types.number),
    rating: types.union(types.undefined, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DriverFamiliarityScoreDtoModelSelector extends QueryBuilder {
  get score() { return this.__attr(`score`) }
  get rating() { return this.__attr(`rating`) }
}
export function selectFromDriverFamiliarityScoreDto() {
  return new DriverFamiliarityScoreDtoModelSelector()
}

export const driverFamiliarityScoreDtoModelPrimitives = selectFromDriverFamiliarityScoreDto().score.rating
